import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';

import { AuthStateService } from './features/auth/services/auth-state.service';
import { LanguageService } from './core/i18n/language.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: `<router-outlet></router-outlet>`
})
export class AppComponent implements OnInit, OnDestroy {
  private authState = inject(AuthStateService);
  private langService = inject(LanguageService);
  private router = inject(Router);
  private readonly sessionExpiredHandler = () => {
    this.authState.logout();
    this.router.navigate(['/login'], {
      queryParams: { expired: 'true' }
    });
  };

  ngOnInit(): void {
    // 1. Fire security checks on boot mirroring splash triggers
    this.authState.checkAuth();

    // 2. Load localized dictionary mapping
    this.langService.init();

    window.addEventListener('lbc:session-expired', this.sessionExpiredHandler);
  }

  ngOnDestroy(): void {
    window.removeEventListener('lbc:session-expired', this.sessionExpiredHandler);
  }
}
